import { Alert, Fade, Snackbar, useTheme } from '@mui/material'
import CloudDoneOutlinedIcon from '@mui/icons-material/CloudDoneOutlined'
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import colors from 'styles/colors'
import { useTranslation } from 'react-i18next'

const NotificationSnackBar = ({
  error,
  success,
  open,
  setOpen,
  autoHideDuration = 3000,
  successText,
  errorText,
  alertProps = {}
}) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const severity = error ? 'error' : success ? 'success' : 'info'
  const message = error
    ? errorText || t('company.failedToSave')
    : success
      ? successText || t('company.changeSaved')
      : t('company.changeSaved')
  const textColor = error
    ? colors.ErrorRed
    : success
      ? colors.Green400
      : colors.MidnightTeal400
  const iconSx = {
    fontSize: 24,
    color: textColor
  }
  const closeSnackbar = () => {
    setOpen(false)
  }
  return (
    <Snackbar
      data-testid='notification-snack'
      open={open}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      slots={{
        transition: Fade
      }}
      transitionDuration={1000}
      autoHideDuration={autoHideDuration}
      onClose={closeSnackbar}>
      <Alert
        severity={severity}
        onClose={closeSnackbar}
        iconMapping={{
          success: <CloudDoneOutlinedIcon sx={iconSx} />,
          error: <CloudDownloadOutlinedIcon sx={iconSx} />,
          info: <InfoOutlinedIcon sx={iconSx} />
        }}
        sx={{
          width: 540,
          height: 48,
          padding: '8px 16px',
          borderRadius: 2.5,
          border: `1px solid ${error ? colors.ErrorRed : success ? colors.Green300 : colors.GoldenYellow300}`,
          backgroundColor: error
            ? colors.SecondaryLightRed
            : success
              ? colors.Green100
              : colors.GoldenYellow100,
          alignItems: 'center',
          boxShadow: '0px 0px 15px 0px rgba(0, 0, 0, 0.25)',
          '& .MuiAlert-message': {
            ...theme.typography.body1,
            color: textColor,
            padding: 0
          },
          '& .MuiButtonBase-root .MuiSvgIcon-root': iconSx
        }}
        {...alertProps}>
        {message}
      </Alert>
    </Snackbar>
  )
}
export default NotificationSnackBar
